import React from 'react';
import Logon from '../App/Logon';

export default function Page_Logon () {
  return <Logon />
}
